const yesNoDropdown = [
    { id: 'N', label: 'No' },
    { id: 'Y', label: 'Yes' }
];

export const yesNoDropdownBool = [
    { id: false, label: 'No' },
    { id: true, label: 'Yes' }
];

export default yesNoDropdown;
